
export const srcProjections = [
    { code: '', name: 'Select Coordinate System' },
    { code: 'EPSG:27700', name: 'British National Grid' },
    { code: 'EPSG:4326', name: 'WGS 84' },
    { code: 'EPSG:3857', name: 'Web Mercator' },
];

export const reProjections = [
    { code: 'EPSG:27700', name: 'British National Grid' },
    { code: 'EPSG:4326', name: 'WGS 84' },
    { code: 'EPSG:3857', name: 'Web Mercator' },
];

export const destProjections = [
    { code: 'EPSG:4326', name: 'WGS 84' },
    { code: 'EPSG:3857', name: 'Web Mercator' },
    { code: 'EPSG:27700', name: 'British National Grid' },
];
